import { getAuthHeaders, makeApiCall } from '../../utils/apiConfig';

export class SystemApiError extends Error {
  code?: string;
  status: number;
  constructor(message: string, status: number, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export async function systemJson<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = await getAuthHeaders();
  const response = await makeApiCall(path, {
    ...init,
    headers: {
      ...headers,
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
      ...(init.headers || {}),
    },
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok || json?.success === false) {
    const message =
      json?.error?.message ||
      (typeof json?.error === 'string' ? json.error : null) ||
      json?.message ||
      `Request failed (${response.status})`;
    throw new SystemApiError(message, response.status, json?.error?.code || json?.code);
  }
  return (json.data !== undefined ? json.data : json) as T;
}

export function asDate(value: unknown): Date | null {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof value === 'object') {
    const seconds = (value as { seconds?: number; _seconds?: number }).seconds ?? (value as { _seconds?: number })._seconds;
    if (typeof seconds === 'number') return new Date(seconds * 1000);
  }
  return null;
}

export const PRIVACY_SLA_DAYS = 30;
export const CLOSED_VISIBLE_DAYS = 90;

export function privacyDue(requestedAt: unknown, now = Date.now()): { due: Date; daysLeft: number } | null {
  const requested = asDate(requestedAt);
  if (!requested) return null;
  const due = new Date(requested.getTime() + PRIVACY_SLA_DAYS * 24 * 60 * 60 * 1000);
  return { due, daysLeft: Math.ceil((due.getTime() - now) / (24 * 60 * 60 * 1000)) };
}

export function isRecent(value: unknown, now = Date.now()): boolean {
  const date = asDate(value);
  if (!date) return false;
  return now - date.getTime() <= CLOSED_VISIBLE_DAYS * 24 * 60 * 60 * 1000;
}
